export const environment = {
  production: true,
  baseUrl: 'https://www.designerbodyzcentre.com',
  // backendbaseUrl: 'http://192.168.29.42/july22/designer-bodyz/public/api/',
  // backendimageUrl: 'http://192.168.29.42/july22/designer-bodyz/public/api/',
  backendbaseUrl: 'https://api.designerbodyzcentre.com/api/',
  backendimageUrl: 'https://api.designerbodyzcentre.com/',
  doc_imageURL: "https://api.designerbodyzcentre.com/storage",

};
